import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=011d75c0&scoped=true&"
import script from "./ProfileTab.vue?vue&type=script&lang=js&"
export * from "./ProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTab.vue?vue&type=style&index=0&id=011d75c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011d75c0",
  null
  
)

export default component.exports